import { Box, IconButton } from "@chakra-ui/react";
import { TrashIcon } from "@phosphor-icons/react/dist/ssr";

// "Borrar perímetros" — clears the entire polygon stack + q + city +
// neighborhood (D17 rule 3), camera untouched. MapPane only mounts this
// when polygons.length >= 1. Label flips between singular/plural based on
// count so it stays grammatically clean (per-polygon delete is filed as
// DW.boundary.per-polygon-delete and isn't in this slice).
//
// Responsive: icon-only square below md, icon + label pill at md+. Symmetric
// with DibujarButton so all three top-right controls share the same
// collapse behavior on narrow screens.
const BoundaryButton = ({ polygons, onClear }) => {
    if (!Array.isArray(polygons) || polygons.length === 0) return null;
    const label = polygons.length > 1 ? "Borrar perímetros" : "Borrar perímetro";
    const sharedStyles = {
        bg: "white",
        color: "gray.900",
        borderWidth: "1px",
        borderColor: "gray.300",
        borderRadius: "full",
        boxShadow: "md",
        _hover: { bg: "gray.50" },
    };
    return (
        <>
            <Box hideFrom="md">
                <IconButton
                    onClick={onClear}
                    aria-label={label}
                    title={label}
                    size="sm"
                    minW="36px"
                    w="36px"
                    px={0}
                    {...sharedStyles}
                >
                    <TrashIcon weight="bold" />
                </IconButton>
            </Box>
            <Box hideBelow="md">
                <IconButton
                    onClick={onClear}
                    aria-label={label}
                    size="sm"
                    px={4}
                    w="auto"
                    minW="auto"
                    {...sharedStyles}
                >
                    <TrashIcon weight="bold" />
                    <Box as="span" ml={2}>
                        {label}
                    </Box>
                </IconButton>
            </Box>
        </>
    );
};

export default BoundaryButton;
